// extracted by mini-css-extract-plugin
export var chatHtmlText = "_r0-2";
export var chatLink = "_r0-0";
export var chatText = "_r0-1";